<template>
    <table class="table table-hover table-striped table-responsive">
        <tbody>
            <tr
                v-for="(value, key) in loopSAW"
                :key="key"
            >
                <td class="nowrap">
                    <strong>
                        <span v-if="key === 'otherSum'">
                            Totalsumma
                        </span>
                        <span v-else>
                            {{ key }}
                        </span>
                    </strong>
                </td>

                <td class="full-width">
                    <div v-if="showInputs">
                        <div
                            v-if="key === 'Vattenarbete'"
                            style="display: flex; align-items: center;"
                        >
                            <input
                                v-model="waterwork"
                                type="number"
                                class="form-control"
                            >
                            <span style="white-space: nowrap; margin-left: 10px;">
                                x {{ coeffs.waterwork }}
                            </span>
                        </div>

                        <div
                            v-if="key === 'Skottfasthet'"
                            style="display: flex; align-items: center;"
                        >
                            <input
                                v-model="shotReaction"
                                type="number"
                                class="form-control"
                            >
                            <span style="white-space: nowrap; margin-left: 10px;">
                                x {{ coeffs.shot_reaction }}
                            </span>
                        </div>

                        <div v-if="key === 'Delsumma'">
                            {{ partSum }}p
                        </div>

                        <div v-else-if="key === 'Datum'">
                            <flatpickr
                                v-model="dateDone"
                                name="dateDone"
                                class="form-control"
                                :config="flatpickrConfig"
                            />
                        </div>

                        <div v-else-if="key === 'Domare'">
                            <multiselect
                                v-model="selectedReferees"
                                :options="allReferees"
                                label="name"
                                value="id"
                                track-by="id"
                                :multiple="true"
                                :close-on-select="false"
                                placeholder="Referees"
                            />
                        </div>
                    </div>

                    <div v-else-if="key === 'Domare'">
                        <span
                            v-for="referee in selectedReferees"
                            :key="referee.id"
                        >
                            {{ referee.name }}<br>
                        </span>
                    </div>

                    <div v-else-if="key === 'Vattenarbete'">
                        {{ waterwork }}p x {{ coeffs.waterwork }} = {{ waterworkSum }}p
                    </div>

                    <div v-else-if="key === 'Skottfasthet'">
                        {{ shotReaction }}p x {{ coeffs.shot_reaction }} = {{ shotReactionSum }}p
                    </div>

                    <div v-else-if="key === 'Delsumma'">
                        {{ waterworkSum }}p + {{ shotReactionSum }}p = {{ partSum }}p
                    </div>

                    <div v-else-if="key === 'Datum'">
                        {{ dateDone }}
                    </div>
                </td>
            </tr>

            <tr v-if="showInputs">
                <td colspan="2">
                    <div>
                        <delete-button
                            classes="btn btn-primary pull-right"
                            title="Är du säker? Detta kan inte ångras!"
                            confirm-button="Spara resultat"
                            text=""
                            action=""
                            :submit-fn="saveShotAndWater"
                        >
                            Spara resultat
                        </delete-button>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
import axios from 'axios';
import Multiselect from '@vueform/multiselect';
import flatpickr from 'vue-flatpickr-component'
import deleteButton from 'vue@/components/deleteButton.vue'
import { cloneDeep } from 'lodash';

export default {
    components: {
        Multiselect,
        flatpickr,
        deleteButton,
    },
    props: {
        shotAndWater: {
            type: Object,
            required: true,
        },
        registrationId: {
            type: Number,
            required: true,
        },
        eventId: {
            type: Number,
            required: true,
        },
    },
    data() {
        const loopSAW = cloneDeep(this.shotAndWater);
        delete loopSAW.isEmpty;
        delete loopSAW.otherSum;
        delete loopSAW.coeffs;

        const waterwork = this.shotAndWater.Vattenarbete;
        const shotReaction = this.shotAndWater.Skottfasthet;

        const { otherSum, isEmpty, coeffs } = this.shotAndWater;

        return {
            loopSAW,
            dateDone: this.shotAndWater.Datum,
            selectedReferees: this.shotAndWater.Domare.current,
            allReferees: this.shotAndWater.Domare.all,
            waterwork,
            shotReaction,
            otherSum,
            coeffs,
            showInputs: isEmpty,

            flatpickrConfig: {
                altInput: true,
                altInputClass: 'form-control',
                dateFormat: 'Y-m-d H:i',
                altFormat: 'Y-m-d H:i',
                allowInput: true,
                enableTime: true,
            },
            loading: false,
            leaveRoute: route('events::show', 1),
        };
    },
    computed: {
        waterworkSum() {
            return Number(this.waterwork) * this.coeffs.waterwork;
        },
        shotReactionSum() {
            return Number(this.shotReaction) * this.coeffs.shot_reaction;
        },
        partSum() {
            return this.waterworkSum + this.shotReactionSum;
        },
        totalSum() {
            return Number(this.partSum) + Number(this.otherSum);
        },
    },
    watch: {
        totalSum(newVal) {
            this.$emit('update:totalsum', newVal, this.partSum);
        },
    },
    mounted() {
        this.$emit('update:totalsum', this.totalSum, this.partSum);
    },
    methods: {
        async saveShotAndWater() {
            if (this.loading) {
                return;
            }

            this.loading = true;
            const url = route('events::results::tjtk::shot-and-water::save', {
                huntingTestEvent: this.eventId,
                huntingTestRegistration: this.registrationId,
            });

            try {
                await axios.post(url, {
                    waterwork: this.waterwork,
                    shotReaction: this.shotReaction,
                    dateDone: this.dateDone,
                    selectedReferees: this.selectedReferees,
                });

                this.showInputs = false;
            } catch (error) {
                console.error(error);
                alert('Resulaten kunde inte sparas, vänligen försök igen.');
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>
